import { render, staticRenderFns } from "./ProductTeaser.vue?vue&type=template&id=29423739&"
import script from "./ProductTeaser.js?vue&type=script&lang=js&"
export * from "./ProductTeaser.js?vue&type=script&lang=js&"
import style0 from "./ProductTeaser.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports